import type { ReactNode } from 'react'
import React from 'react'
import { csx, IconXCircle, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { useGenericErrorLogger } from '../../../../../../core/hooks/useGenericErrorLogger'
import type { GenericErrorProps } from '../../../../../../core/screens/GenericError'
import { ShelfWithoutDataContainer } from '../ShelfWithoutDataContainer'

export type ShelfErrorStateProps = GenericErrorProps & {
  title: string | ReactNode
  description: string | ReactNode
  workflowType: string
}

export const ShelfErrorState = ({
  title,
  description,
  error,
  errorId,
  workflowType,
  ...props
}: ShelfErrorStateProps) => {
  useGenericErrorLogger({
    error,
    errorId,
    workflowType,
  })

  return (
    <ShelfWithoutDataContainer {...props}>
      <div
        className={csx({
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        })}
      >
        <IconXCircle
          width={32}
          height={32}
          className={csx({ color: '$gray30', marginBottom: '$space-3' })}
        />
        <Text variant="action1">{title}</Text>
        <Text variant="detail" className={csx({ color: '#858585 !important' })}>
          {description}
        </Text>
      </div>
      <div
        className={csx({
          position: 'absolute',
          bottom: 0,
          width: '100%',
          textAlign: 'center',
          paddingBottom: '$space-5',
        })}
      >
        <Text variant="detail" className={csx({ color: '#ADADAD !important' })}>
          <FormattedMessage
            id="generic-error-code"
            values={{ value: errorId }}
          />
        </Text>
      </div>
    </ShelfWithoutDataContainer>
  )
}
